import { motion } from "framer-motion";
import { Mail, MapPin, MessageCircle } from "lucide-react";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { SocialButtons } from "@/components/SocialButtons";

const fadeUp = {
  hidden: { opacity: 0, y: 30 },
  visible: (i = 0) => ({ opacity: 1, y: 0, transition: { delay: i * 0.1, duration: 0.6, ease: "easeOut" } }),
};

export default function ContactPage() {
  return (
    <div className="min-h-screen bg-champagne" data-testid="contact-page">
      <Navbar />

      <section className="pt-32 pb-24 px-6">
        <div className="max-w-3xl mx-auto">
          {/* Header */}
          <motion.div initial="hidden" animate="visible" variants={fadeUp} className="text-center mb-16">
            <h1 className="font-heading text-4xl md:text-5xl font-semibold text-charcoal leading-tight mb-4">
              Get in Touch
            </h1>
            <p className="font-body text-charcoal-light text-lg max-w-xl mx-auto leading-relaxed">
              Have a question about services, the journal, or just want to connect?
              Reach out — Joyce would love to hear from you.
            </p>
          </motion.div>

          {/* Contact Cards */}
          <div className="space-y-6 mb-12">
            {/* WhatsApp */}
            <motion.a
              href="https://wa.me/6597946649"
              target="_blank" rel="noopener noreferrer"
              initial="hidden" animate="visible" variants={fadeUp} custom={1}
              data-testid="contact-whatsapp"
              className="block p-8 rounded-2xl bg-navy text-white hover:shadow-lift transition-all"
            >
              <div className="w-12 h-12 bg-white/20 rounded-2xl flex items-center justify-center mb-4">
                <MessageCircle className="w-6 h-6 text-white" />
              </div>
              <p className="font-body text-xs text-white/70 mb-1">WhatsApp</p>
              <p className="font-heading text-xl font-semibold text-white mb-2">WhatsApp Joyce</p>
              <p className="font-body text-sm text-white/80">The quickest way to reach Joyce</p>
            </motion.a>

            {/* Email */}
            <motion.a
              href="mailto:happyjourneywithjoyce@gmail.com"
              initial="hidden" animate="visible" variants={fadeUp} custom={2}
              data-testid="contact-email"
              className="block p-8 rounded-2xl border bg-white border-border hover:shadow-lift transition-all"
            >
              <div className="w-12 h-12 bg-navy/10 rounded-2xl flex items-center justify-center mb-4">
                <Mail className="w-6 h-6 text-navy" />
              </div>
              <p className="font-body text-xs text-charcoal-light mb-1">Email</p>
              <p className="font-heading text-xl font-semibold text-charcoal mb-2">happyjourneywithjoyce@gmail.com</p>
              <p className="font-body text-sm text-charcoal-light">For enquiries and follow-ups</p>
            </motion.a>

            {/* Social Media */}
            <motion.div
              initial="hidden" animate="visible" variants={fadeUp} custom={3}
              className="p-8 rounded-2xl border bg-white border-border"
            >
              <p className="font-heading text-lg font-semibold text-charcoal mb-4">Follow Joyce</p>
              <SocialButtons />
            </motion.div>

            {/* Location */}
            <motion.div
              initial="hidden" animate="visible" variants={fadeUp} custom={4}
              data-testid="contact-location"
              className="p-8 rounded-2xl border bg-white border-border"
            >
              <div className="w-12 h-12 bg-navy/10 rounded-2xl flex items-center justify-center mb-4">
                <MapPin className="w-6 h-6 text-navy" />
              </div>
              <p className="font-body text-xs text-charcoal-light mb-1">Location</p>
              <p className="font-heading text-xl font-semibold text-charcoal mb-2">Singapore</p>
              <p className="font-body text-sm text-charcoal-light">Sessions available in-person & online</p>
            </motion.div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
